import { render, staticRenderFns } from "./3D.vue?vue&type=template&id=0859ff78"
import script from "./3D.vue?vue&type=script&lang=js"
export * from "./3D.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports